/**
 * AppProvider - Combines all context providers for the application
 */

import React, { ReactNode } from 'react';
import { ModalProvider } from './ModalContext';
import { LoanProvider } from './LoanContext';
import { UserProvider } from './UserContext';

interface AppProviderProps {
  children: ReactNode;
}

/**
 * AppProvider combines all context providers in the correct order
 * Providers are nested from outermost (most general) to innermost (most specific)
 */
export function AppProvider({ children }: AppProviderProps): React.JSX.Element {
  return (
    <UserProvider>
      <LoanProvider>
        <ModalProvider>
          {children}
        </ModalProvider>
      </LoanProvider>
    </UserProvider>
  );
}

export default AppProvider;
